export interface InitialRisk {
  time: number
  venueProduct: string
  risk: number
  notional: number
  price: number
}

export enum RISK_SOURCE {
  CONFIG = 'CONFIG',
  PAIRED_NODE = 'PAIRED_NODE',
  STRATEGY_DATABASE = 'STRATEGY_DATABASE',
}

export interface StrategyInitialRisk {
  timestamp: string // nanosecond precision
  locked: boolean
  selected: RISK_SOURCE
  sources: Record<RISK_SOURCE, InitialRisk[]>
}
